import $http from '../services/AxiosInstance';
import { ISecurityMeasures } from '../types/securityMeasures.type';

interface Params {
  page?: number;
  search?: string;
  companyId?: number;
  deleted?: boolean;
}

class SecurityMeasuresRepository {
  static async getSecurityMeasures(params: Params = {}) {
    try {
      let url = `/security-measures/pro`;
      if (params.page) {
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.companyId) {
        url += `&companyId=${params.companyId}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async getAllSecurityMeasures() {
    try {
      let url = `/security-measures`;

      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createSecurityMeasure(
    data: ISecurityMeasures,
  ): Promise<ISecurityMeasures> {
    try {
      const response = await $http.post('/security-measures', data);

      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async updateSecurityMeasure(
    data: ISecurityMeasures,
  ): Promise<ISecurityMeasures> {
    try {
      const response = await $http.patch(`/security-measures/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async deleteSecurityMeasure(id: number): Promise<number> {
    try {
      const response = await $http.delete(`/security-measures/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
  static async restoreSecurityMeasure(id: number): Promise<number> {
    try {
      const response = await $http.post(`/security-measures/restore/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
}

export default SecurityMeasuresRepository;
